export const warehouseConstants = {
    WAREHOUSE_RESET: 'WAREHOUSE_RESET',
    WAREHOUSE_FETCH_COMPLETED: 'WAREHOUSE_FETCH_COMPLETED',   
    WAREHOUSE_SET_DATA: 'WAREHOUSE_SET_DATA',
    WAREHOUSE_DELETE_DATA: 'WAREHOUSE_DELETE_DATA'
};